// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1400px) {
    .container-custom {
        padding-left: 15px;
        padding-right: 15px;
    }

    .productHover .image-div:hover .additional-image {
        left: 0;
    }

    .productHover .image-div:hover .outofstock {
        left: 50%;
    }

    .productHover .image-div:hover .addtocart {
        bottom: 0;
    }

    .productHover .image-div:hover .bedge {
        left: 10px;
    }

    .productHover .image-div:hover .buttons {
        right: 0;
    }

    .productHover .image-div:hover .counter {
        left: 50%;
    }

    /* h1 {
        font-size: 40px !important;
        line-height: 45px !important;
    }

    h2 {
        font-size: 36px !important;
        line-height: 41px !important;
    }

    h3 {
        font-size: 32px !important;
        line-height: 37px !important;
    }

    h4 {
        font-size: 26px !important;
        line-height: 33px !important;
    }

    h5 {
        font-size: 22px !important;
        line-height: 29px !important;
    }

    h6 {
        font-size: 18px !important;
        line-height: 25px !important;
    } */

}

@media (max-width: 1399px) {
    .productHover .outofstock {
        width: 100px;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-transform: capitalize;
        position: absolute;
        text-align: center;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: ease 0.4s;
    }

    /* 
    .main-slider .swiper-button-next {
        right: 80px;
        left: auto;
    }

    .main-slider .swiper-button-prev {
        left: 80px;
        right: auto;
    }

    .main-slider .swiper-button-next:after,
    .main-slider .swiper-button-prev:after {
        font-size: 30px;
        opacity: 0;
        transition: all 0.6s;
    }

    .main-slider:hover .swiper-button-next:after,
    .main-slider:hover .swiper-button-prev:after {
        opacity: 1;
    } */

    /* h1 {
        font-size: 40px !important;
        line-height: 45px !important;
    }

    h2 {
        font-size: 36px !important;
        line-height: 41px !important;
    }

    h3 {
        font-size: 32px !important;
        line-height: 37px !important;
    }

    h4 {
        font-size: 28px !important;
        line-height: 33px !important;
    }

    h5 {
        font-size: 24px !important;
        line-height: 29px !important;
    }

    h6 {
        font-size: 20px !important;
        line-height: 25px !important;
    } */
}

@media (max-width: 1199px) {
    .productHover .outofstock {
        width: 100px;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-transform: capitalize;
        position: absolute;
        text-align: center;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: ease 0.4s;
    }

    /* .main-slider .swiper-button-next {
        right: 80px;
        left: auto;
    }

    .main-slider .swiper-button-prev {
        left: 80px;
        right: auto;
    }

    .main-slider .swiper-button-next:after,
    .main-slider .swiper-button-prev:after {
        font-size: 30px;
        opacity: 0;
        margin: 0;
        transition: all 0.6s;
    }

    .-slider .swiper-button-next:after,
    .main-slider .swiper-button-prev:after {
        font-size: 30px;
        opacity: 0;
        margin: 0;
        transition: all 0.6s;
    }

    .main-slider:hover .swiper-button-next:after,
    .main-slider:hover .swiper-button-prev:after {
        opacity: 1;
    } */
}

@media (max-width: 991px) {
    .productHover .image-div {
        left: 0 !important;
    }

    /* .main-slider .swiper-button-next {
        right: 80px;
        left: auto;
    }

    .main-slider .swiper-button-prev {
        left: 80px;
        right: auto;
    }

    .main-slider .swiper-button-next:after,
    .main-slider .swiper-button-prev:after {
        opacity: 1;
    } */

    /* h1 {
        font-size: 38px !important;
        line-height: 43px !important;
    }

    h2 {
        font-size: 34px !important;
        line-height: 37px !important;
    }

    h3 {
        font-size: 30px !important;
        line-height: 35px !important;
    }

    h4 {
        font-size: 26px !important;
        line-height: 31px !important;
    }

    h5 {
        font-size: 22px !important;
        line-height: 28px !important;
    }

    h6 {
        font-size: 18px !important;
        line-height: 23px !important;
    } */
}

@media (max-width: 767px) {
    /* .main-slider .swiper-button-next {
        right: 30px;
        left: auto;
    }

    .main-slider .swiper-button-prev {
        left: 30px;
        right: auto;
    } */


    /* h1 {
        font-size: 32px !important;
        line-height: 43px !important;
    }

    h2 {
        font-size: 34px !important;
        line-height: 37px !important;
    }

    h3 {
        font-size: 30px !important;
        line-height: 35px !important;
    }

    h4 {
        font-size: 26px !important;
        line-height: 31px !important;
    }

    h5 {
        font-size: 22px !important;
        line-height: 28px !important;
    }

    h6 {
        font-size: 16px !important;
        line-height: 23px !important;
    } */

    .category-slider .swiper-wrapper {
        height: 260px !important;
    }
}

@media (max-width: 575px) {
    .container-custom {
        /* width: 100% !important; */
        padding-right: var(--bs-gutter-x, 0.75rem);
        padding-left: var(--bs-gutter-x, 0.75rem);
        margin-right: auto;
        margin-left: auto;
    }

    .bottom-nav {
        display: flex;
    }

    .fixed-atc {
        bottom: 40px;
        padding: 0 70px;
    }

    .chat {
        left: 20px;
        bottom: 60px;
    }

    .backtotop {
        bottom: 60px;
        right: 20px;
    }

    .footer {
        margin-bottom: 40px;
    }

    /* .main-slider .swiper-button-next {
        right: 0px;
        left: auto;
    }

    .main-slider .swiper-button-prev {
        left: 0px;
        right: auto;
    } */
    details>div:last-child {
        padding-bottom: 16px !important;
    }

    details>button:last-child {
        margin-bottom: 16px !important;
        margin-left: 16px !important;
    }

    details>div {
        padding: 0px 16px 0px 16px !important;
    }

    details summary {
        padding: 16px !important;
        position: relative;
    }

    /* h1 {
        font-size: 32px !important;
        line-height: 43px !important;
    }

    h2 {
        font-size: 34px !important;
        line-height: 37px !important;
    }

    h3 {
        font-size: 30px !important;
        line-height: 35px !important;
    }

    h4 {
        font-size: 26px !important;
        line-height: 31px !important;
    }

    h5 {
        font-size: 22px !important;
        line-height: 28px !important;
    }

    h6 {
        font-size: 16px !important;
        line-height: 23px !important;
    } */
}`, "",{"version":3,"sources":["webpack://./src/Media.css"],"names":[],"mappings":"AAAA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,OAAO;IACX;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,SAAS;IACb;;IAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;OA4BG;;AAEP;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;QACb,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,0BAA0B;QAC1B,kBAAkB;QAClB,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,gCAAgC;QAChC,qBAAqB;IACzB;;IAEA;;;;;;;;;;;;;;;;;;;;;OAqBG;;IAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;;OA4BG;AACP;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;QACb,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,0BAA0B;QAC1B,kBAAkB;QAClB,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,gCAAgC;QAChC,qBAAqB;IACzB;;IAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;OA6BG;AACP;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;;;;;;;;;;;;;OAaG;;IAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;;OA4BG;AACP;;AAEA;IACI;;;;;;;;OAQG;;;IAGH;;;;;;;;;;;;;;;;;;;;;;;;;;;;OA4BG;;IAEH;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,4BAA4B;QAC5B,0CAA0C;QAC1C,yCAAyC;QACzC,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;;;;;;;OAQG;IACH;QACI,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;QAC9B,4BAA4B;IAChC;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,wBAAwB;QACxB,kBAAkB;IACtB;;IAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;OA4BG;AACP","sourcesContent":["@media (min-width: 1400px) {\n    .container-custom {\n        padding-left: 15px;\n        padding-right: 15px;\n    }\n\n    .productHover .image-div:hover .additional-image {\n        left: 0;\n    }\n\n    .productHover .image-div:hover .outofstock {\n        left: 50%;\n    }\n\n    .productHover .image-div:hover .addtocart {\n        bottom: 0;\n    }\n\n    .productHover .image-div:hover .bedge {\n        left: 10px;\n    }\n\n    .productHover .image-div:hover .buttons {\n        right: 0;\n    }\n\n    .productHover .image-div:hover .counter {\n        left: 50%;\n    }\n\n    /* h1 {\n        font-size: 40px !important;\n        line-height: 45px !important;\n    }\n\n    h2 {\n        font-size: 36px !important;\n        line-height: 41px !important;\n    }\n\n    h3 {\n        font-size: 32px !important;\n        line-height: 37px !important;\n    }\n\n    h4 {\n        font-size: 26px !important;\n        line-height: 33px !important;\n    }\n\n    h5 {\n        font-size: 22px !important;\n        line-height: 29px !important;\n    }\n\n    h6 {\n        font-size: 18px !important;\n        line-height: 25px !important;\n    } */\n\n}\n\n@media (max-width: 1399px) {\n    .productHover .outofstock {\n        width: 100px;\n        height: 100px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        text-transform: capitalize;\n        position: absolute;\n        text-align: center;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        transition: ease 0.4s;\n    }\n\n    /* \n    .main-slider .swiper-button-next {\n        right: 80px;\n        left: auto;\n    }\n\n    .main-slider .swiper-button-prev {\n        left: 80px;\n        right: auto;\n    }\n\n    .main-slider .swiper-button-next:after,\n    .main-slider .swiper-button-prev:after {\n        font-size: 30px;\n        opacity: 0;\n        transition: all 0.6s;\n    }\n\n    .main-slider:hover .swiper-button-next:after,\n    .main-slider:hover .swiper-button-prev:after {\n        opacity: 1;\n    } */\n\n    /* h1 {\n        font-size: 40px !important;\n        line-height: 45px !important;\n    }\n\n    h2 {\n        font-size: 36px !important;\n        line-height: 41px !important;\n    }\n\n    h3 {\n        font-size: 32px !important;\n        line-height: 37px !important;\n    }\n\n    h4 {\n        font-size: 28px !important;\n        line-height: 33px !important;\n    }\n\n    h5 {\n        font-size: 24px !important;\n        line-height: 29px !important;\n    }\n\n    h6 {\n        font-size: 20px !important;\n        line-height: 25px !important;\n    } */\n}\n\n@media (max-width: 1199px) {\n    .productHover .outofstock {\n        width: 100px;\n        height: 100px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        text-transform: capitalize;\n        position: absolute;\n        text-align: center;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        transition: ease 0.4s;\n    }\n\n    /* .main-slider .swiper-button-next {\n        right: 80px;\n        left: auto;\n    }\n\n    .main-slider .swiper-button-prev {\n        left: 80px;\n        right: auto;\n    }\n\n    .main-slider .swiper-button-next:after,\n    .main-slider .swiper-button-prev:after {\n        font-size: 30px;\n        opacity: 0;\n        margin: 0;\n        transition: all 0.6s;\n    }\n\n    .-slider .swiper-button-next:after,\n    .main-slider .swiper-button-prev:after {\n        font-size: 30px;\n        opacity: 0;\n        margin: 0;\n        transition: all 0.6s;\n    }\n\n    .main-slider:hover .swiper-button-next:after,\n    .main-slider:hover .swiper-button-prev:after {\n        opacity: 1;\n    } */\n}\n\n@media (max-width: 991px) {\n    .productHover .image-div {\n        left: 0 !important;\n    }\n\n    /* .main-slider .swiper-button-next {\n        right: 80px;\n        left: auto;\n    }\n\n    .main-slider .swiper-button-prev {\n        left: 80px;\n        right: auto;\n    }\n\n    .main-slider .swiper-button-next:after,\n    .main-slider .swiper-button-prev:after {\n        opacity: 1;\n    } */\n\n    /* h1 {\n        font-size: 38px !important;\n        line-height: 43px !important;\n    }\n\n    h2 {\n        font-size: 34px !important;\n        line-height: 37px !important;\n    }\n\n    h3 {\n        font-size: 30px !important;\n        line-height: 35px !important;\n    }\n\n    h4 {\n        font-size: 26px !important;\n        line-height: 31px !important;\n    }\n\n    h5 {\n        font-size: 22px !important;\n        line-height: 28px !important;\n    }\n\n    h6 {\n        font-size: 18px !important;\n        line-height: 23px !important;\n    } */\n}\n\n@media (max-width: 767px) {\n    /* .main-slider .swiper-button-next {\n        right: 30px;\n        left: auto;\n    }\n\n    .main-slider .swiper-button-prev {\n        left: 30px;\n        right: auto;\n    } */\n\n\n    /* h1 {\n        font-size: 32px !important;\n        line-height: 43px !important;\n    }\n\n    h2 {\n        font-size: 34px !important;\n        line-height: 37px !important;\n    }\n\n    h3 {\n        font-size: 30px !important;\n        line-height: 35px !important;\n    }\n\n    h4 {\n        font-size: 26px !important;\n        line-height: 31px !important;\n    }\n\n    h5 {\n        font-size: 22px !important;\n        line-height: 28px !important;\n    }\n\n    h6 {\n        font-size: 16px !important;\n        line-height: 23px !important;\n    } */\n\n    .category-slider .swiper-wrapper {\n        height: 260px !important;\n    }\n}\n\n@media (max-width: 575px) {\n    .container-custom {\n        /* width: 100% !important; */\n        padding-right: var(--bs-gutter-x, 0.75rem);\n        padding-left: var(--bs-gutter-x, 0.75rem);\n        margin-right: auto;\n        margin-left: auto;\n    }\n\n    .bottom-nav {\n        display: flex;\n    }\n\n    .fixed-atc {\n        bottom: 40px;\n        padding: 0 70px;\n    }\n\n    .chat {\n        left: 20px;\n        bottom: 60px;\n    }\n\n    .backtotop {\n        bottom: 60px;\n        right: 20px;\n    }\n\n    .footer {\n        margin-bottom: 40px;\n    }\n\n    /* .main-slider .swiper-button-next {\n        right: 0px;\n        left: auto;\n    }\n\n    .main-slider .swiper-button-prev {\n        left: 0px;\n        right: auto;\n    } */\n    details>div:last-child {\n        padding-bottom: 16px !important;\n    }\n\n    details>button:last-child {\n        margin-bottom: 16px !important;\n        margin-left: 16px !important;\n    }\n\n    details>div {\n        padding: 0px 16px 0px 16px !important;\n    }\n\n    details summary {\n        padding: 16px !important;\n        position: relative;\n    }\n\n    /* h1 {\n        font-size: 32px !important;\n        line-height: 43px !important;\n    }\n\n    h2 {\n        font-size: 34px !important;\n        line-height: 37px !important;\n    }\n\n    h3 {\n        font-size: 30px !important;\n        line-height: 35px !important;\n    }\n\n    h4 {\n        font-size: 26px !important;\n        line-height: 31px !important;\n    }\n\n    h5 {\n        font-size: 22px !important;\n        line-height: 28px !important;\n    }\n\n    h6 {\n        font-size: 16px !important;\n        line-height: 23px !important;\n    } */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
